// src/assets/styles/selectStyles.js
export const selectStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  menu: (base) => ({ ...base, marginTop: "5px", zIndex: 9999 }),
  control: (provided) => ({ ...provided, padding: "1px" }),
  valueContainer: (provided) => ({ ...provided, padding: "3px 6px" }),
};

export const selectStyleDisable = {
  menuPortal: base => ({ ...base, zIndex: 9999, position: 'absolute', top: 'auto', bottom: '100%' }),
  menu: base => ({ ...base, marginTop: '5px', zIndex: 9999 }),
  control: (provided, state) => ({
    ...provided, padding: '1px', backgroundColor: state.isDisabled ? '#e4e4e4' : 'white',
    borderColor: state.isDisabled ? '#ccc' : provided.borderColor,
    cursor: state.isDisabled ? 'not-allowed' : 'default',
    opacity: 1,
    pointerEvents: state.isDisabled ? 'auto' : 'auto',
  }),
}